import React, { useEffect, useMemo, useState } from "react";
import { RefundsService, RequestsService } from "../../../../api";
import CancellationDecisionPanel from "./CancellationDecisionPanel"
import CancellationStatusBanner from "./CancellationStatusBanner"
import RefundExecutionPanel from "./RefundExecutionPanel";

type PaymentInfo = {
  status: string;
  totalPaid: number;
  totalPayable: number;
  payments?: any[];
};

type Props = {
  requestId: number;
  cancellationReason?: string;
  paymentInfo: PaymentInfo;
  requestStatus: string;
  requestSubStatus: string;
  adminId: number;
  onRefresh?: () => void;
};

const CancelRequestProcessor: React.FC<Props> = ({
  requestId,
  cancellationReason,
  requestStatus,
  requestSubStatus,
  paymentInfo,
  adminId,
  onRefresh,
}) => {

  const hasPayments = paymentInfo.totalPaid > 0;

  const showDecision =
    requestSubStatus === "Cancellation Requested";

  const showRefund =
    requestSubStatus === "Cancellation Accepted" && hasPayments;

  const refundCompleted =
    requestSubStatus === "Refund Processed";

  return (
    <div className="space-y-6">
      {/* <CancellationStatusBanner status={requestSubStatus} /> */}

      {showDecision && (
        <CancellationDecisionPanel
          requestId={requestId}
          adminId={adminId}
          cancellationReason={cancellationReason}
          paymentInfo={paymentInfo}
          onActionComplete={onRefresh}
        />
      )}

      {showRefund && (
        <RefundExecutionPanel
          requestId={requestId}
          adminId={adminId}
          paymentInfo={paymentInfo}
          onRefundComplete={onRefresh}
        />
      )}

      {refundCompleted && (
        <p className="text-green-700 font-medium">
          Refund successfully processed.
        </p>
      )}
    </div>
  );
};

export default CancelRequestProcessor;